import script from "./Btn.vue?vue&type=script&setup=true&lang=ts"
export * from "./Btn.vue?vue&type=script&setup=true&lang=ts"

import "./Btn.vue?vue&type=style&index=0&id=d684d3b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d684d3b6"]])

export default __exports__